import { Outlet, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import '../navigation.css';

const Layout = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [pageCustomer, setPageCustomer] = useState("Customers");
  const [pageInventory, setPageInventory] = useState("Inventory");

  // Check login status
  useEffect(() => {
    const checkLoginStatus = () => {
      const cookies = new Cookies();
      const login = cookies.get('login');
      setIsLoggedIn(!!login);
    };

    checkLoginStatus();
    const interval = setInterval(checkLoginStatus, 1000);
    return () => clearInterval(interval);
  }, []);

  // Get customer and inventory display names from localStorage
  useEffect(() => {
    const getDisplayNames = () => {
      try {
        const attributes = JSON.parse(localStorage.getItem('attributes') || '[]');
        const customerAttributes = attributes.find(attr => attr.assignment === 'customers');
        const inventoryAttributes = attributes.find(attr => attr.assignment === 'inventory');
        
        if (customerAttributes && customerAttributes.displayplural) {
          setPageCustomer(customerAttributes.displayplural);
        }
        if (inventoryAttributes && inventoryAttributes.displayplural) {
          setPageInventory(inventoryAttributes.displayplural);
        }
      } catch (error) {
        console.log('Could not load attributes:', error);
      }
    };

    if (isLoggedIn) {
      getDisplayNames();
    }
  }, [isLoggedIn]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  // Don't show navigation if not logged in
  if (!isLoggedIn) {
    return <main className="main-content"><Outlet /></main>;
  }

  return (
    <>
      <nav className="fancy-nav">
        <div className="nav-container">
          <div className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`}>
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'nav-link-active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/Customers"
              className={`nav-link ${isActive('/Customers') ? 'nav-link-active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {pageCustomer}
            </Link>
            <Link
              to="/Inventory"
              className={`nav-link ${isActive('/Inventory') ? 'nav-link-active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {pageInventory}
            </Link>
            <Link
              to="/About"
              className={`nav-link ${isActive('/About') ? 'nav-link-active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/usermaint"
              className={`nav-link ${isActive('/usermaint') ? 'nav-link-active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              User Maint
            </Link>
            <Link
              to="/Logout"
              className={`nav-link nav-link-logout ${isActive('/Logout') ? 'nav-link-active' : ''}`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Logout
            </Link>
          </div>

          <div className="nav-toggle" onClick={toggleMobileMenu}>
            <span className={`hamburger ${isMobileMenuOpen ? 'hamburger-open' : ''}`}></span>
            <span className={`hamburger ${isMobileMenuOpen ? 'hamburger-open' : ''}`}></span>
            <span className={`hamburger ${isMobileMenuOpen ? 'hamburger-open' : ''}`}></span>
          </div>
        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>
    </>
  )
};

export default Layout;